import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionService } from '../services/permission.service';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private permissions: PermissionService, private auth: AuthService) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (!this.auth.isLoggedIn()) { this.auth.login(); return of(false); }
    // 确保从当前 token 更新一次权限缓存
    this.permissions.ensureFresh();
    return of(this.permissions.isAdmin());
  }
}


